export enum TabsEnum {
  OVERVIEW = 'overview',
  MARKET_DATA = 'market-data',
  RENTER_DATA = 'renter-data',
  AD_SPEND = 'adspend',
  MARKET_REPORTS = 'industry-reports',
  MARKET_COMPS = 'market-comps',
}

export type TabsConfigItem = {
  tab: TabsEnum;
  label: string;
};

export const tabsConfig: Array<TabsConfigItem> = [
  {
    tab: TabsEnum.OVERVIEW,
    label: 'Overview',
  },
  {
    tab: TabsEnum.MARKET_DATA,
    label: 'Market data',
  },
  {
    tab: TabsEnum.RENTER_DATA,
    label: 'Renter data',
  },
  {
    tab: TabsEnum.AD_SPEND,
    label: 'Ad spend',
  },
  {
    tab: TabsEnum.MARKET_REPORTS,
    label: 'Industry reports',
  },
  {
    tab: TabsEnum.MARKET_COMPS,
    label: 'Competitor insights',
  },
];
